<section>
    <form [formGroup]="requestAccessForm">
        <h1>Request Access to EZ DOCS</h1>

        <div>
            <p>
                Please complete the form below and we will send an email to the EZ DOCS system administrator(s) letting
                them know you would like to be added as a user.
            </p>
        </div>
        <ng-template #sent>
            <div>Email Sent!</div>
        </ng-template>

        <hr />

        <div>
            <mat-form-field>
                <mat-label>First Name</mat-label>
                <input matInput formControlName="firstName" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Last Name</mat-label>
                <input formControlName="lastName" matInput />
            </mat-form-field>
        </div>

        <div>
            <mat-form-field>
                <mat-label>Email</mat-label>
                <input formControlName="email" matInput />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Mobile</mat-label>
                <input formControlName="mobilePhone" matInput appPhoneMask placeholder="(XXX) XXX-XXXX"
                    maxlength="14" />
            </mat-form-field>
        </div>

        <div class="buttons">
            <button mat-button class="secondary" (click)="cancel()">Cancel</button>
            <button mat-button class="primary" (click)="submit()">Submit</button>
        </div>
    </form>
</section>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>